import { ValueType } from '@nibras/core/common';

export class dcValueClassType {
  public ValueTypeID: number;
  public ValueClassName: string;
  public ValueClassType: ValueClassType;
  public AssemblyName: string;
  public PrimitiveValueTypeID: ValueType;
  public DisplayFormat: ValueType;
  public LookUpQueryID: number;
}

export enum ValueClassType {
  PrimitiveType = 1,
  EnumerationSet = 2,
  Class = 3,
  Array = 4,
  FormulaFunction = 5,
  Methods = 6, //Take care while merging this code to PU - Value of Methods in PU is 5, a update script needs to be added.
  MultiSelect = 7
}
